import { render, staticRenderFns, recyclableRender, components } from "./uni-drawer.vue?vue&type=template&id=56836304&scoped=true&"
var renderjs
import script from "./uni-drawer.vue?vue&type=script&lang=js&"
export * from "./uni-drawer.vue?vue&type=script&lang=js&"
import style0 from "./uni-drawer.vue?vue&type=style&index=0&id=56836304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56836304",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-drawer/uni-drawer.vue"
export default component.exports